import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import ButtonBase from '@mui/material/ButtonBase'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import logo from '@/assets/images/sofor_logo.svg'

export const Logo = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  const matchesSM = useMediaQuery(theme.breakpoints.down('lg'))

  const handleRedirect = useCallback(() => {
    navigate('/dashboard')
  }, [matchesSM, navigate])

  return (
    <ButtonBase
      disableRipple
      onClick={handleRedirect}
      sx={{ display: 'flex', justifyContent: 'flex-start', height: '70%' }}
    >
      <img alt={'TC Şoför'} src={logo} width={'100%'} />
    </ButtonBase>
  )
}
